import React from 'react';

import PageLayout from '../../layouts/inner-page-layout';
import WhitelabelSetupPage from './whitelabel-setup-page';

export class PaymentPage extends React.Component {
	render() {
		return (
			<div>
				<PageLayout>
					<WhitelabelSetupPage />
				</PageLayout>
			</div>
		);
	}
}

export default PaymentPage;



// WEBPACK FOOTER //
// ./src/containers/whitelabel-page/index.js